<div class="row">
  @if (categories) {
    @for (category of categories; track category) {
      <div class="row list-row m-b-16">
        <div class="col-12 list-row-item" [class.col-md-4]="columns > 1">
          <span class="f-s-14">{{category[categoryName]}}</span><br>
          <span class="header-link" (click)="onSelectAllClicked(category[optionsKey])">
            {{('List_Picker.Select_All' | trans)}}
          </span> /
          <span class="header-link" (click)="onDeselectAllClicked(category[optionsKey])">
            {{('List_Picker.Deselect_All' | trans)}}
          </span>
        </div>
        <div class="col-12" [class.col-md-8]="columns > 1">
          <div class="row">
            @for (option of category[optionsKey]; track option) {
              <div class="col-12"
                [class.col-sm-12]="columns === 1"
                [class.col-sm-6]="columns === 2"
                [class.col-sm-4]="columns === 3">
                <div class="form-check m-b-8">
                  <label>
                    <input type="checkbox"
                      [checked]="inSelection(option)"
                      (change)="updateSelection(option)">
                    <span class="label">
                      {{option[optionName]}}
                      @if (optionSubtitle) {
                        <div class="subtitle">{{option[optionSubtitle]}}</div>
                      }
                    </span>
                  </label>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  }
</div>
